import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgYellowPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.30552 10.6948H4.16663V9.30589H9.30552V4.16699H10.6944V9.30589H15.8333V10.6948H10.6944V15.8337H9.30552V10.6948Z",
		fill: "#B06803"
	})
});
export default SvgYellowPlus;
